import type {
  BookArrival,
  ExternalBookSource,
} from 'stores/photoBooksStore/PhotoBooksStore'
import type { LoginNoticeTitleKey } from './loginNotice'

export type BookArrivalNoticeContent = {
  name: string
  titleKey: string
  bookCount?: number
  analyticsProperties?: {
    Source: ExternalBookSource
    'Books Added': number
  }
}

function getArrivalTitleKey(bookCount: number, isGreeting: boolean): string {
  if (isGreeting) {
    return bookCount === 1
      ? 'photo_book.arrival_notice.login_title_one'
      : 'photo_book.arrival_notice.login_title_other'
  }
  return bookCount === 1
    ? 'photo_book.arrival_notice.title_one'
    : 'photo_book.arrival_notice.title_other'
}

export function getBookArrivalNoticeContent({
  arrival,
  loginTitleKey,
}: {
  arrival: BookArrival | null
  loginTitleKey: LoginNoticeTitleKey | null
}): BookArrivalNoticeContent | null {
  if (!arrival) {
    if (!loginTitleKey) return null
    return { name: 'Login Success', titleKey: loginTitleKey }
  }

  const bookCount = arrival.addedBookIds.length
  return {
    name: 'Book Arrival',
    titleKey: getArrivalTitleKey(bookCount, Boolean(loginTitleKey)),
    bookCount,
    analyticsProperties: { Source: arrival.source, 'Books Added': bookCount },
  }
}
